import { APPLICATION_V2_CONTINUE_PATH } from "../resumePath"
import { redirectToLogoutOnUnauthorized, UNAUTHORIZED_SESSION_MESSAGE } from "./unauthorizedRedirect"

const borrowerSideV2Fetch = async (path, options = {}) => {
    const token = window.sessionStorage.getItem("ZeitroA")
    const response = await fetch(window.location.origin + path, {
        cache: "no-cache",
        ...options,
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
    })

    if (response.status === 401) {
        redirectToLogoutOnUnauthorized()
        throw new Error(UNAUTHORIZED_SESSION_MESSAGE)
    }

    const body = await response.json().catch(() => ({}))
    if (!response.ok || body.Status === "Error") {
        throw new Error(body.Message || body.Text || body.errMessage || "BorrowerSide V2 request failed")
    }
    return body
}

export const getLoansV2 = () => borrowerSideV2Fetch("/borrowerside/v2/loans")

export const switchLoanV2 = (loanId) => (
    borrowerSideV2Fetch("/borrowerside/v2/loans/switch", {
        method: "POST",
        body: JSON.stringify({ loanId }),
    })
)

export { APPLICATION_V2_CONTINUE_PATH }
